import { render, staticRenderFns } from "./ItalyXML.vue?vue&type=template&id=0ad84120&scoped=true&"
import script from "./ItalyXML.vue?vue&type=script&lang=js&"
export * from "./ItalyXML.vue?vue&type=script&lang=js&"
import style0 from "./ItalyXML.vue?vue&type=style&index=0&id=0ad84120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad84120",
  null
  
)

export default component.exports